module.exports = __webpack_public_path__ + "static/img/8.cada3ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/sp/8.png
// module id = rp6E
// module chunks = 0